var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-guide-container"},[_c('iframe',{ref:"userGuideFrame",staticClass:"user-guide-iframe",attrs:{"src":"/user-guide/index.html","title":"User Guide Documentation"},on:{"load":_vm.onIframeLoad,"error":_vm.onIframeError}})])
}
var staticRenderFns = []

export { render, staticRenderFns }